import { combineReducers } from 'redux'
import  {reducer as uniscrowReducer}  from './slices/uniscrow'

export const createRootReducer = () => combineReducers({
    uniscrow: uniscrowReducer,
})